import * as React from 'react';
import { Box, Flex } from '.';
import { StyleSheet, css } from 'aphrodite';

interface ThreeColumnLayoutProps {
    statusColumn: any;
    descriptionColumn: any;
    actionColumn: any;
}
export const ThreeColumnLayout: React.SFC<ThreeColumnLayoutProps> = (props) => {
    const { statusColumn, descriptionColumn, actionColumn } = props;
    return (
        <Flex flexDirection={'row'}>
            <Box className={css(styles.centredRow)} ml="18px" mt="auto" mb="auto" width="52px" >
                {statusColumn}
            </Box>
            <Box mt="8px" mb="12px" ml="18px" width="100%">
                {descriptionColumn}
            </Box>
            <Box className={css(styles.centredRow)} mt="auto" mb="auto" ml="18px" mr="18px" width="125px">
                {actionColumn}
            </Box>
        </Flex>
    );
};

const styles = StyleSheet.create({
    centredRow: {
        textAlign: 'center'
    },
});
